import React, { useContext, useEffect } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';

import '../css/GuidedTourLauncher.less';

import { SatCoreRegister } from '../SatCoreRegistry';

import GuidedTourService from '../services/GuidedTourService';

const GuidedTourLauncher = observer((_props) => {
  const { topNavManager } = useContext(MobXProviderContext);

  // Extract the observable value so it can be used in dependency array
  const { activeTopNavName } = topNavManager;

  useEffect(() => {
    // Clean up any existing guided tour before initializing new one
    // This prevents "Lightbox already exists" errors when switching between TopNavs
    GuidedTourService.removeGuidedTourLauncherIfApplicable();

    // Initialize guided tour for the current TopNav
    GuidedTourService.initGuidedTour();
  }, [activeTopNavName]);

  return (<></>);
});
export default GuidedTourLauncher;

SatCoreRegister('GuidedTourLauncher', GuidedTourLauncher);
